// The coach panel's card pieces (Figma "Coach panel · web", 51:4106): one
// card frame for every thread card (question, proposal, change, safety,
// working, phase review), its eyebrow, and the teal "Why?" link that closes a
// card's action row. Local to the coach area; the ds kit has no card yet.
import React from 'react';
import { cn } from '../../lib/utils';
import { FOCUS } from '../ds';

const TONE = {
  plain: 'border-border-subtle bg-bg-surface',
  accent: 'border-accent-tint-border bg-bg-surface',     // waits on the athlete: a question, a suggestion, working
  proposal: 'border-accent-default bg-accent-tint',       // the plan proposal
  danger: 'border-status-danger bg-bg-surface',           // safety
};

export function CoachCard({ tone = 'plain', className, children, ...props }) {
  return (
    <div className={cn('flex flex-col gap-2 rounded-2xl border p-3.5 text-left', TONE[tone], className)} {...props}>
      {children}
    </div>
  );
}

const EYEBROW = {
  accent: 'text-accent-default',
  muted: 'text-text-tertiary',
  danger: 'text-status-danger',
};

export function Eyebrow({ tone = 'accent', className, children }) {
  return <p className={cn('m-0 flex items-center gap-1.5 type-eyebrow uppercase', EYEBROW[tone], className)}>{children}</p>;
}

/** The card's headline (Figma Label/Section). */
export function CardTitle({ className, children }) {
  return <p className={cn('m-0 type-label-section text-text-primary', className)}>{children}</p>;
}

/** A card's action row: the buttons, then the Why? link pushed to the end. */
export function CardActions({ className, children }) {
  return <div className={cn('flex flex-wrap items-center gap-2', className)}>{children}</div>;
}

export function WhyLink({ onClick, className }) {
  return (
    <button type="button" onClick={onClick}
      className={cn('ml-auto min-h-[32px] rounded-full px-1 type-label text-accent-default hover:text-accent-hover', FOCUS, className)}>
      Why?
    </button>
  );
}
